import { Instance } from 'mobx-state-tree';
import { ShopifyOrderImportOrderResultDtoModelBase } from './ShopifyOrderImportOrderResultDtoModel.base';

/* The TypeScript type of an instance of ShopifyOrderImportOrderResultDtoModel */
export interface ShopifyOrderImportOrderResultDtoModelType extends Instance<typeof ShopifyOrderImportOrderResultDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyOrderImportOrderResultDtoModel */
export { selectFromShopifyOrderImportOrderResultDto, shopifyOrderImportOrderResultDtoModelPrimitives, ShopifyOrderImportOrderResultDtoModelSelector } from './ShopifyOrderImportOrderResultDtoModel.base';

/**
 * ShopifyOrderImportOrderResultDtoModel
 */
export const ShopifyOrderImportOrderResultDtoModel = ShopifyOrderImportOrderResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
